import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncCreateDealFromLeadModal = Loadable({
  loader: () => import('./CreateDealFromLeadModal').then(mod => mod.CreateDealFromLeadModal)
});